import React, { useState, useEffect } from "react";
import { useNavigate,useParams } from "react-router-dom";
import { api } from '../../api';
import Moment from "moment";
import MerchantSummary from "./MerchantSummary";
import { useQuery } from "../hooks/useQuery";
import DataTable from "react-data-table-component";
import { customStyles } from "../../styles/dataTableStyles";
import { useSelector,useDispatch } from "react-redux";
import { setSwitchRegion  } from "../../redux/authSlice";
import { decimalTo } from '../../utils/utils';

export default function Orders(props) {
  // eslint-disable-next-line 
  const today = new Date().toISOString().split("T")[0];
  // eslint-disable-next-line 
  const ref = React.useRef(null);
  const navigate = useNavigate();
  const query = useQuery();
  const dispatch = useDispatch();

  const token = useSelector((state) => state.auth.token);
  
  // eslint-disable-next-line 
  const [updateData, setUpdateData] = useState(false);
  const [orderList, setOrderList] = useState([]);
  // eslint-disable-next-line
  const [startDate, setStartDate] = useState('');
  // eslint-disable-next-line
  const [endDate, setEndDate] = useState('');
  // eslint-disable-next-line 
  const [reportStatus, setReportstatus] = useState(localStorage.getItem("status"));
  // eslint-disable-next-line 
  const [reportLoad, setReportLoad] = useState(false);
   // eslint-disable-next-line 
  const [updatedReports, setupdatedReports] = useState({});
  const { id, type, name } = useParams();

  // eslint-disable-next-line
  const [merchentId, setMerchantId] = useState(id);
  // eslint-disable-next-line
  const [productId, setProductId] = useState(id);
  // eslint-disable-next-line
  const [orderType, setOrderType] = useState(type);
  // eslint-disable-next-line
  const [date, setDate] = useState(localStorage.getItem("startDate"));
  // eslint-disable-next-line
  const [lastDate, setLastDate] = useState(localStorage.getItem("endDate"));
  // eslint-disable-next-line
  const [merchentName, setMerchentName] = useState("");
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);


  const { id: mId } = useParams();
  const isMerchantReport = query.get("reportInput") === 'merchent';
  const isSaleReport = query.get("reportInput") === 'sale';
    useEffect(() => {
      dispatch(setSwitchRegion(false));
  
      return () => {
          dispatch(setSwitchRegion(true)); // reset when unmounting
      };
      }, [dispatch]);

    useEffect(() => {
      handleClick();
      // eslint-disable-next-line
    }, [page,pageSize,token]);

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      cell: (row, index) => (
        <>
          {index + 1}
          <input type="hidden" value={row.orderId} readOnly />
        </>
      ),
      sortable: false,
    },
    {
      name: "Order Date",
      selector: (row) => row.orderDate,
      cell: (row) => {
        const date = new Date(row.orderDate);
        return <span>{date.toLocaleString()}</span>; // shows date and time
      },
      sortable: true,
    },
    {
      name: "Merchant Name",
      selector: row => row.merchentName,
      cell: row => row.merchentName ? <span className="add-ellip">{row.merchentName}</span> : null,
    },
    {
      name: "Order ID",
      selector: row => row.orderNo,
    },
    {
      name: "Products",
      selector: row => row.ordersItems,
      cell: row => row.ordersItems ? <span className="add-ellip">{row.ordersItems}</span> : null,
    },
    {
      name: "Total Quantity",
      selector: row => row.ordersQuantity,
    },
    {
      name: "Total Net Amount",
      selector: row => row.orderAmount,
      cell: row => <span>{row.orderAmount != null ? decimalTo(row.orderAmount).toFixed(2) : "0.00"}</span>,
    },
    {
      name: "Available Amount",
      selector: row => row.balanceCredit,
      cell: row => <span>{row.balanceCredit != null ? decimalTo(row.balanceCredit).toFixed(2) : "0.00"}</span>,
    },
    {
      name: "Status",
      selector: row => row.status,
      cell: row => {
        let orderClass = row.status === "Completed" ? "Cann" :
                         row.status === "Cancelled" ? "Inactive" : "";
        return <span className={orderClass}><span>{row.status}</span></span>;
      }
    },
    {
      name: "Action",
      cell: row => (
        <span className="view-btn" onClick={() => handleView(null, row.orderId)}>
          <p className="ViewButton">View</p>
        </span>
      ),
      ignoreRowClick: true,
    
      button: true,
    }
  ];


// eslint-disable-next-line
  const handleClick = () => {
    const type = orderType;
    let formBody = {};

    if (type === "product") {
      formBody = {
        pageNo: page,
        pageSize: pageSize,
        sort: "",
        sortBy: "",
        searchKey: "",
        productId,
        startDate,
        endDate,
      };
    } else {
      formBody = {
        pageNo: page,
        pageSize: pageSize,
        sort: "",
        sortBy: "",
        searchKey: "",
        merchentId,
        startDate,
        endDate,
      };
    }

    api.orders
      .getOrdersData(formBody,token)
      .then((res) => {
        if (res.success) {
          setOrderList(res.data.result);
          setupdatedReports(res.data);
          setTotalRows(res.data.totalCount);
          setReportLoad(true);
          setUpdateData(true);
        }
      })
      .catch((err) => console.log("error", err));
  };

  function handleDetail(row) {
    navigate(`/orders-details/${row}`);
  }

  function handleView(e, rowId) {
    if (e) e.stopPropagation();
    navigate(`/orders-info/${rowId}`);
  }

  function handleGoback() {
    const strtDate = query.get("startDate");
    const endDate = query.get("endDate");
    const reportInput = query.get("reportInput");
    const statusTypeQuery = query.get("statusType");
    navigate(`/reports?startDate=${strtDate}&endDate=${endDate}&reportInput=${reportInput}${isSaleReport ? `&statusType=${statusTypeQuery}` : ''}`);
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <div className="table-head">
              <h1 className="sec-header">
                {orderType !== "sales"
                  ? merchentName && <>Order Details of - {merchentName}</>
                  : <>Order Details {name}</>
                }
              </h1>
              <div className="row" style={{
                display: "flex",
                alignItems: "center",
                padding: "0px 15px",
                justifyContent: 'space-between'
              }}>
                <div className="form-group">
                  {orderType !== "sales" ? (
                    <>
                      <p>Start Date - {Moment(date).format("DD-MM-YYYY")}</p>
                      <p>End Date - {Moment(lastDate).format("DD-MM-YYYY")}</p>
                    </>
                  ) : (
                    <p>Date - {Moment(id).format("DD-MM-YYYY")}</p>
                  )}
                  {orderType === "sales" && <p>Status - {reportStatus}</p>}
                </div>
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-primary mr-4"
                    style={{ borderRadius: "50%" ,float: "right"}}
                    onClick={handleGoback}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
            {isMerchantReport && <MerchantSummary mid={mId} />}
            <div className="card card-table">
              <div className="card-body gatepass-saveoutput">
                <div className="reports">
                  <DataTable
                    columns={columns}
                    data={orderList}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={page}
                    onChangePage={setPage}
                    onChangeRowsPerPage={(newPageSize, newPage) => {
                      setPageSize(newPageSize);
                      setPage(newPage); // Reset to selected page
                    }}
                    highlightOnHover
                    pointerOnHover
                    customStyles={customStyles}
                    onRowClicked={(row) => handleDetail(row.orderId)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
